module.exports = __webpack_public_path__ + "img/controller-xbox360.49cd1ae2.png";